import React from 'react';
import styled from '@emotion/styled';
const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${(props)=>props.isOpen ? 'block' : 'none'};
  opacity: ${(props)=>props.isOpen ? 1 : 0};
  transition: opacity 0.3s ease;
  
  @media (min-width: 768px) {
    display: none;
  }
`;
const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--theme-paper, #ffffff);
  z-index: 1000;
  transform: translateX(${(props)=>props.isOpen ? '0' : '100%'});
  transition: transform 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  @media (min-width: 768px) {
    display: none;
  }
`;
export const MobileChatOverlay = ({ isOpen, chatType, onClose, onSwitchToAIChat, onSwitchToUserChat, chatComponents })=>{
    const renderChatContent = ()=>{
        if (chatType === 'ai') {
            const { ChatProvider, ChatModal } = chatComponents || {};
            if (!ChatProvider || !ChatModal) {
                return /*#__PURE__*/ React.createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        padding: '20px',
                        textAlign: 'center',
                        color: 'var(--theme-text-muted, #666)'
                    }
                }, "AI 채팅 기능을 사용할 수 없습니다");
            }
            return /*#__PURE__*/ React.createElement(ChatProvider, {}, /*#__PURE__*/ React.createElement(ChatModal, {
                isOpen: true,
                onClose,
                isSidebarMode: true,
                onSwitchToUserChat
            }));
        } else {
            const { PeopleChatModal } = chatComponents || {};
            if (!PeopleChatModal) {
                return /*#__PURE__*/ React.createElement("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        padding: '20px',
                        textAlign: 'center',
                        color: 'var(--theme-text-muted, #666)'
                    }
                }, "사용자 채팅 기능을 사용할 수 없습니다");
            }
            return /*#__PURE__*/ React.createElement(PeopleChatModal, {
                onSwitchToAIChat,
                onClose
            });
        }
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ React.createElement(Overlay, {
        isOpen: isOpen
    }, /*#__PURE__*/ React.createElement(Container, {
        isOpen: isOpen
    }, renderChatContent()));
};
export default MobileChatOverlay;
